import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

//middelware
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Axios from "axios";

//ckeditor

import { SwalError } from "../../../../utils/constants";

import { create, getById, update } from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";

export const ManageRevistas = () => {
  const { REVISTAS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { isAdmin } = useSelector(({ user }) => user);

  const history = useHistory();
  const [isCreate, setIsCreate] = useState(false);

  const [titulo, setTitulo] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [editor, setEditor] = useState("");
  const [issn, setIssn] = useState("");
  const [periodicidad, setPeriodicidad] = useState("");
  const [urlLibro, setUrlLibro] = useState("");
  const [idiomaLibro, setIdiomaLibro] = useState("");
  const [obsBiblioteca, setObsBiblioteca] = useState('')
  const [signatura, setSignatura] = useState('')
  const [anyosIncompletos, setAnyosIncompletos] = useState('')
  const [disponibilidad, setDisponibilidad] = useState(false)

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    // loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadData = async () => {
    try {
      let response = await getById(REVISTAS, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  // prettier-ignore
  const buildObjToLoad = (response) => {
    const {
      ciudad,
      titulo,
      editor,
      periodicidad,
      issn,
      urlLibro,
      idiomaLibro,
      disponibilidad,
      signatura,
      obsBiblioteca,
      anyosIncompletos,
  
    } = response;
   


    setCiudad(ciudad);
    setTitulo(titulo);
	setEditor(editor);
    setIdiomaLibro(idiomaLibro);
    setDisponibilidad(disponibilidad ? '1' : '0')
    setSignatura(signatura)
    setObsBiblioteca(obsBiblioteca)
    setAnyosIncompletos(anyosIncompletos)   
	setIssn(issn);
	setPeriodicidad(periodicidad);
	setUrlLibro(urlLibro);


	if (isMountedRef.current) 
	setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const revistas = build();
    //     const notValid = validate(revistas);
    //     if (notValid) {
    //       setMessage(notValid);
    //       setTimeout(() => setMessage(""), 4000);
    //       return;
    //     }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} revista?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed &&
        handleConfirmation(
          revistas  
             );
    });
  };

  const handleConfirmation = (
    revistas   
  ) => {
    let createOrUpdate = isCreate
      ? create(REVISTAS, revistas, source)
      : update(REVISTAS, id, revistas, source);
    createOrUpdate
      .then(async ({ id }) => {
        Swal.fire({
          icon: "success",
          text: `Revista ${isCreate ? "creada" : "editada"} correctamente.`,
        });

        history.push(`${ROUTES.Revistas.all}/${id}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => {
    return {
      
      titulo,
      ciudad,
      editor,
      idiomaLibro,
      disponibilidad: disponibilidad === '1' ? true : false,
      signatura,
      obsBiblioteca,
      anyosIncompletos,
      issn,
      periodicidad,
      urlLibro,
    };
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Revista
        </button>
      );
    }
    if ((!isCreate) || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() => deleteIt(REVISTAS, id, ROUTES.Revistas.all, source)}
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Revistas </h3>
            </div>
            <div>{editDeleteButtons()}</div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>*Título</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título"
              value={titulo}
              onChange={({ target: { value } }) => {
                setTitulo(value);
              }}
            />
          </div>
          <div className="col">
            <small>Ciudad</small>
            <input
              type="text"
              className="form-control"
              placeholder="Ciudad"
              value={ciudad}
              onChange={({ target: { value } }) => {
                setCiudad(value);
              }}
            />
          </div>
          <div className="col">
            <small>Editor</small>
            <input
              type="text"
              className="form-control"
              placeholder="Editor"
              value={editor}
              onChange={({ target: { value } }) => {
                setEditor(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Idioma libro</small>
            <input
              type="text"
              className="form-control"
              placeholder="Idioma libro"
              value={idiomaLibro}
              onChange={({ target: { value } }) => {
                setIdiomaLibro(value);
              }}
            />
          </div>
          <div className="col">
            <small>Obs biblioteca</small>
            <input
              type="text"
              className="form-control"
              placeholder="Obs biblioteca"
              value={obsBiblioteca}
              onChange={({ target: { value } }) => {
                setObsBiblioteca(value);
              }}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Disponibilidad?</small>
            <select
              className="form-control input"
              value={disponibilidad}
              onChange={({ target: { value } }) => {
                setDisponibilidad(value);
              }}
            >
              <option value="">Seleccione una opción</option>
              <option value={0}>No</option>
              <option value={1}>Si</option>
            </select>
          </div>
          <div className="col">
            <small>Signatura</small>
            <input
              type="text"
              className="form-control"
              placeholder="Signatura"
              value={signatura}
              onChange={({ target: { value } }) => {
                setSignatura(value);
              }}
            />
          </div>
        </div>

        {(isCreate || allowedEdit) && (
          <>
            <div className="form-row mt-4">
              <div className="col">
                <small>Issn</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Issn"
                  value={issn}
                  onChange={({ target: { value } }) => {
                    setIssn(value);
                  }}
                />
              </div>
            </div>

            <div className="form-row mt-4">
              <div className="col">
                <small>Periodicidad</small>
                <select
                  className="form-control input"
                  value={periodicidad}
                  onChange={({ target: { value } }) => {
                    setPeriodicidad(value);
                  }}
                >
                  <option value="">Seleccione una opción</option>
                  <option value='opcion1'>Opción 1</option>
                  <option value='opcion2'>Opción 2</option>
                  <option value="opcion3">Opción 3</option>
                </select>
              </div>
              <div className="col">
                <small>Años incompletos</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Años incompletos"
                  value={anyosIncompletos}
                  onChange={({ target: { value } }) => {
                    setAnyosIncompletos(value);
                  }}
                />
              </div>
            </div>
            <div className="form-row mt-4">
              <div className="col">
                <small>Url</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="url"
                  value={urlLibro}
                  onChange={({ target: { value } }) => {
                    setUrlLibro(value);
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
